import { FavouriteConditionValue } from 'app/types-shared';
import { ConditionValuesOperator, ConditionValuesDbFunction, SubOptionTypes, FilterTypes } from 'app/components/filters/types';
import { createFieldOptionType } from 'app/area/filters/favourite-definition/create-field-option-type';

export const createSubOptionTypeValue = (favouriteConditionValue: FavouriteConditionValue) => {
  const operator = favouriteConditionValue && favouriteConditionValue.hasOwnProperty('operator')
    && favouriteConditionValue.operator.v;
  const dbFunction = favouriteConditionValue && favouriteConditionValue.hasOwnProperty('dbFunction')
    && favouriteConditionValue.dbFunction.v;

  const isMatchExactOperator = operator === ConditionValuesOperator.equal;
  const isMatchExactDbFunction = dbFunction === ConditionValuesDbFunction.upper;

  return isMatchExactOperator && isMatchExactDbFunction && {
    value: favouriteConditionValue.string,
    subOptionTypes: [SubOptionTypes.MatchExact]
  };
};

export const createInitialTextFieldConditions = (favouriteConditionValue: FavouriteConditionValue,
  conditionValues: FavouriteConditionValue[]) => {

  const conditionValuesOperators = {
    [ConditionValuesOperator.empty]: { type: createFieldOptionType(conditionValues)[0] }
  };

  const defaultValue = { value: favouriteConditionValue.string };
  const subOptionTypeValue = createSubOptionTypeValue(favouriteConditionValue);

  const optionTypeOperator = conditionValues[0] && conditionValues[0].operator;
  const optionTypeValue = (optionTypeOperator && conditionValuesOperators[optionTypeOperator.v]);

  return {
    [FilterTypes.TextField]: conditionValues && (optionTypeValue || subOptionTypeValue || defaultValue)
  };
};
